// extracted by mini-css-extract-plugin
module.exports = {"search-loader":"SearchLoader_search-loader__7f5DO","search-loader__image":"SearchLoader_search-loader__image__29UYg"};